<div class="card">
  <h1>
    <span i18n="@@userPendingUserApproval.title"
      >We need to verify your account 🔒</span
    >
  </h1>

  <p>
    <span i18n="@@userPendingUserApproval.firstParagraph"
      >We've just sent you an important email to
      <span class="email">{{ email }}</span
      >. Please check your email immediately and follow the instructions
      to sign in to your account again</span
    >
  </p>
  <p id="last-paragraph">
    <span i18n="@@userPendingUserApproval.lastParagraph"
      ><span class="cerise-text medium2">Hint:</span> Check whether the email
      may have ended up in spam incase it does not appear shortly.</span
    >
  </p>

  <div class="button-wrapper">
    <zaver-primary-button
      text="Back"
      i18n-text="@@userPendingUserApproval.button"
      (click)="backToLogin()"
      [color]="colorService.getCeriseColorCodeAsType()"
    ></zaver-primary-button>
  </div>
</div>
